// local-auth-client.ts — 004-dual-login-2fa T004
// Instance axios SANS intercepteur MSAL, utilisée uniquement pour les endpoints
// d'authentification qui ne requièrent pas de token préalable.
// Décision R-01 dans research.md : deux clients distincts pour éviter tout risque
// de régression sur les appels existants. Configuration commune et mapping
// d'erreurs partagés avec client.ts via http-client-factory.ts.

import type { AxiosInstance } from "axios";

import {
  attachProblemDetailsInterceptor,
  createHttpClient,
} from "@/infrastructure/api/http-client-factory";

const localAuthClient: AxiosInstance = createHttpClient();

// Pas d'intercepteur de requête — ces endpoints sont appelés sans authentification préalable

// Intercepteur response partagé : même mapping ProblemDetails que client.ts
attachProblemDetailsInterceptor(localAuthClient);

export default localAuthClient;
